import { useActionDialogContext } from '../../Context/ActionDialogContext';
import UIStrings from '@/Utils/UIStrings';

function HireDialogBody() {
    const { selectedCandidates } = useActionDialogContext();
    const { name } = selectedCandidates[0];

    return (
        <div className="text-foreground text-sm font-normal">
            <span>{`${UIStrings.HireDialogBody1} `}</span>
            <span>{name}</span>
            <span>{`${UIStrings.HireDialogBody2} `}</span>
        </div>
    );
}

export default HireDialogBody;
